import { useQuery } from "@tanstack/react-query";
import { activitySidebarService } from "../../services/activitySidebar.service";

const POLL_INTERVAL_MS = 30_000;

// SIMS-4338: the "Input Submitted" submission feed for the sidebar. Polls (no
// WebSockets on Lambda — see SIMS-4154) so the feed stays near-real-time.
export const useInputSubmitted = (coordinatorId: string | undefined) => {
	return useQuery({
		queryKey: ["sims-activity-input-submitted", coordinatorId],
		queryFn: () =>
			activitySidebarService.getInputSubmitted(coordinatorId as string),
		enabled: Boolean(coordinatorId),
		staleTime: 15_000,
		gcTime: 300_000,
		refetchInterval: POLL_INTERVAL_MS,
		refetchIntervalInBackground: false,
		refetchOnWindowFocus: true,
	});
};
